<script lang="ts" setup>
import { computed } from 'vue';

defineOptions({
    name: 'IdeoAlert'
});

const props = withDefaults(defineProps<{
    show?: boolean;
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
}>(), {
    show: false,
    variant: 'secondary'
});

const flag = (value: any): boolean =>
{
    return value !== false;
};

const customClasses = computed((): Record<string, boolean> => ({
    alert: true,
    [`alert-${props.variant}`]: true
}));
</script>

<template>
    <div v-if="flag(show)" :class="customClasses">
        <slot name="default" />
    </div>
</template>
